<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import ReturnList from "@/router/views/property/components/returnlist";
import PrintOptions from "@/components/modals/print-options.vue";
import ReturnModal from "@/router/views/property/components/return-modal.vue";
import { groupBy } from "lodash";
export default {
    page: {
        title: "Return Property Request"
    },
    components: {
        Layout,
        PageHeader,
        ReturnList,
        PrintOptions,
        ReturnModal
    },
    data() {
        return {
            title: "Return Property Request",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/"
                },
                {
                    text: "Return Property Request",
                    active: true
                }
            ],
            loading: false,
            tabModel: 0,
            pending: [],
            pendingGrp: [],
            approved: [],
            approvedGrp: [],
            selectedReturn: null,
            isViewing: true,
            returnStatus: ['Missing/Unfound', 'Unserviceable/Beyond Repair', 'Unserviceable/Repairable', 'Others']
        }
    },
    methods: {
        async changeData(campusId) {
            this.tabModel = 0;
            this.loading = true;
            await this.getPendingAssignment(campusId);
            await this.getApprovedAssignment(campusId);
            this.loading = false;
        },
        getName(officer) {
            if (!officer) return "";
            return `${officer.lastName}, ${officer.firstName}`;
        },
        async getPendingAssignment(campusId) {
            try {
                const { data: response } = await this.$store.dispatch("propertyassignment/GetPendingReturnedPropertyAssignment", campusId);
                if (response.error) {
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                response.map(item => {
                    item.assignedTo = this.getName(item.accountableOfficer);
                    item.copyStatus = JSON.parse(JSON.stringify(item.propertyStatus));
                    item.filterKey = `${item.propertyName} ${item.assignedTo}`;
                    item.statusReturn = JSON.parse(JSON.stringify(item.propertyStatus));
                    item.otherReason = null;
                    if(item.propertyStatus && this.returnStatus.indexOf(item.propertyStatus) === -1) {
                        item.otherReason = item.propertyStatus;
                        item.statusReturn = "Others";
                    }
                    item.clamped = false;
                })
                this.pending = response;
                let grp = [];
                let grouped = groupBy(response, "returnGroupId");
                for (const key in grouped) {
                    grp.push({
                        id: key,
                        accountableOfficer: grouped[key][0].accountableOfficer,
                        transactionDate: grouped[key][0].dateReturned,
                        items: grouped[key],
                        filterKey: this.getName(grouped[key][0].accountableOfficer)
                    });
                }
                this.pendingGrp = grp;
            } catch (error) {
                this.showToast("An error occurred while fetching pending returned property assignments.", "error");
            }
        },
        async getApprovedAssignment(campusId) {
            try {
                const { data: response } = await this.$store.dispatch("propertyassignment/GetApprovedReturnedPropertyAssignment", campusId);
                if (response.error) {
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                response.map(item => {
                    item.assignedTo = this.getName(item.accountableOfficer);
                    item.filterKey = `${item.propertyName} ${item.assignedTo}`;
                    item.statusReturn = JSON.parse(JSON.stringify(item.propertyStatus));
                    item.otherReason = null;
                    if(item.propertyStatus && this.returnStatus.indexOf(item.propertyStatus) === -1) {
                        item.otherReason = item.propertyStatus;
                        item.statusReturn = "Others";
                    }
                    item.copyStatus = JSON.parse(JSON.stringify(item.propertyStatus));
                    item.clamped = false;
                })
                let grp = [];
                let grouped = groupBy(response, "returnGroupId");
                for (const key in grouped) {
                    grp.push({
                        id: key,
                        accountableOfficer: grouped[key][0].accountableOfficer,
                        transactionDate: grouped[key][0].dateReturned,
                        items: grouped[key],
                        filterKey: this.getName(grouped[key][0].accountableOfficer)
                    });
                }
                this.approved = response;
                this.approvedGrp = grp;
            } catch (error) {
                this.showToast("An error occurred while fetching approved returned property assignments.", "error");
            }
        },
        approveRequest(item){
            let itemsWoStatus = 0;
            item.items.forEach(i => {
                if(!i.propertyStatus || i.propertyStatus == "") {
                    itemsWoStatus++;
                }
            });
            if(itemsWoStatus > 0) {
                this.$swal({
                    title: "Incomplete Information",
                    text: "Please specify the property status for all items before approving.",
                    icon: "warning",
                    confirmButtonColor: "#34c38f",
                });
                return;
            }
            this.$swal({
                title: "Are you sure?",
                text: "You want to approve this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, approve it!",
            }).then(async (result) => {
                if (result.value) {
                    let res = await this.approveReturnRequest(item);
                    if(res){
                        this.showToast("Return property assignment approved successfully.", "success");
                    }else{
                        this.showToast("Failed to approve the return property assignment.", "error");
                    }
                }
            });
        },
        async approveReturnRequest(item){
            try {
                const { data: response } = await this.$store.dispatch("propertyassignment/ApproveReturnRequest", item.id);
                if (response.error) {
                    return false;
                }
                let index = this.pendingGrp.findIndex(i => i.id == item.id);
                if(index !== -1) {
                    this.pendingGrp.splice(index, 1);
                    this.approvedGrp.unshift(item);
                }
                return true;
            } catch (error) {
                return false;
            }
        },
        printReturnSlip(item) {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Property/ReturnReceipt",
                routeVariables: [item.id],
            });
            this.$bvModal.show("print-options-modal");
        },
        updateItem(item) {
            this.isViewing = false;
            this.selectedReturn = item;
            this.$bvModal.show("return-items");
            this.$refs.returnModal.setItems(item.items);
        },
        viewItems(item) {
            this.isViewing = true;
            this.selectedReturn = item;
            this.$bvModal.show("return-items");
            this.$refs.returnModal.setItems(item.items);
        },
        async proceedUpdating({items, submitApprove}){
            let proceed = true;
            if(submitApprove){
                let resp = await this.$swal({
                    title: "Are you sure?",
                    text: "You want to approve this?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Yes, approve it!",
                })
                proceed = resp.value;
            }
            if(!proceed) return;
            let payload = items.map(i => {
                return {
                    propertyAssignmentId: i.id,
                    propertyStatus: i.statusReturn == "Others" ? i.otherReason : i.statusReturn
                }
            });
            try{
                const { data: response } = await this.$store.dispatch("propertyassignment/UpdateMultiplePropertyStatus", payload);
                if (response.error) {
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                this.selectedReturn.items = JSON.parse(JSON.stringify(items.map(i => {
                    i.propertyStatus = i.statusReturn == "Others" ? i.otherReason : i.statusReturn;
                    return i;
                })));
                if(submitApprove) {
                    let itemsWoStatus = 0;
                    items.forEach(i => {
                        if(!i.propertyStatus || i.propertyStatus == "") {
                            itemsWoStatus++;
                        }
                    });
                    if(itemsWoStatus > 0) {
                        this.$swal({
                            title: "Incomplete Information",
                            text: "Please specify the property status for all items before approving.",
                            icon: "warning",
                            confirmButtonColor: "#34c38f",
                        });
                        return;
                    }
                    let res = await this.approveReturnRequest(this.selectedReturn);
                    if(res){
                        this.showToast("Return property assignment approved successfully.", "success");
                    }else{
                        this.showToast("Failed to approve the return property assignment.", "error");
                    }
                }else{
                    this.showToast("Return property assignment updated successfully.", "success");
                }
                this.$bvModal.hide("return-items");
            }catch(error) {
                this.showToast("An error occurred while updating the return property assignment.", "error");
                return;
            }
        }
    },
    async created() {
        this.changeData(this.$store.state.data.selectedCampus.id);
    }
}
</script>
<template>
    <Layout @changeCampus="changeData($event.id)">
        <PageHeader :title="title" :items="items" />
        <b-tabs
            content-class="pt-3 pb-3 text-muted"
            v-model="tabModel"
            nav-class="nav-tabs-custom"
        >
            <b-tab>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="mdi mdi-cancel"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Pending</span>
                </template>
                <ReturnList 
                    :items="pending" 
                    :groupedItems="pendingGrp" 
                    :loading="loading" 
                    @approve="approveRequest" 
                    @view="viewItems"
                    @update="updateItem"
                    @print-slip="printReturnSlip"
                    type="pending"
                />
            </b-tab>
            <b-tab>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="mdi mdi-cancel"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Approved</span>
                </template>
                <ReturnList 
                    :items="approved" 
                    :groupedItems="approvedGrp" 
                    :loading="loading"  
                    @print-slip="printReturnSlip"
                    @view="viewItems"
                    type="approved"
                />
            </b-tab>
        </b-tabs>
        <print-options ref="printOpt"></print-options>
        <ReturnModal ref="returnModal" :modalTitle="'Returned Items'" @update-items="proceedUpdating" :viewing="isViewing"></ReturnModal>
    </Layout>
</template>